module.exports = __webpack_public_path__ + "static/full01-4ec243023987ad1f3b46d95d8968721e.png";